// extracted by mini-css-extract-plugin
export default {"headerContainer":"passwordforgetform_headerContainer__hx5ts","closeImg":"passwordforgetform_closeImg__lIf1A"};